(() => {
  'use strict';
  if (window.llCollectionSortReady) return;
  window.llCollectionSortReady = true;

  const allowedSorts = new Set(['manual', 'created-descending', 'price-ascending', 'price-descending']);
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-collection-sort]');
    if (!select || !select.closest('[data-collection-sort-form]') || !allowedSorts.has(select.value)) return;
    const url = new URL(window.location.href);
    // Shopify sorts the full matching collection before pagination. Keep the
    // current collection/tag path and query filters, but start the new order at page 1.
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.assign(url.href);
  });
})();
